module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reportManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("举报审核")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_vm._v("\n    时间：\n    "), _c('div', {
    staticClass: "time"
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "placeholder": "请选择开始时间"
    },
    model: {
      value: (_vm.beginAt),
      callback: function($$v) {
        _vm.beginAt = $$v
      },
      expression: "beginAt"
    }
  })], 1), _vm._v("\n    -\n    "), _c('div', {
    staticClass: "time"
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "placeholder": "请选择结束时间"
    },
    model: {
      value: (_vm.endAt),
      callback: function($$v) {
        _vm.endAt = $$v
      },
      expression: "endAt"
    }
  })], 1), _vm._v("\n    状态：\n    "), _c('div', {
    staticClass: "time"
  }, [_c('el-select', {
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "全部状态"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "已通过"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "未通过"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "未审核"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.list,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80px;"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportId",
      "label": "举报人ID",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportNum",
      "label": "举报人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cheatReason",
      "label": "作弊说明 ",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportTimeText",
      "label": "举报时间",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status == 2) ? _c('div', [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 3) ? _c('div', [_vm._v("未通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 1) ? _c('div', [_vm._v("未审核")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.showImg(_vm.row.imageUrls)
              }
            }
          }, [_vm._v("详情")]), _vm._v(" "), (_vm.row.status !== 2) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.passOperate(_vm.row, 2)
              }
            }
          }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 1) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.passOperate(_vm.row, 3)
              }
            }
          }, [_vm._v("不通过")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.totalCount > 0),
      expression: "this.totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": 10,
      "current-page": _vm.currentPage,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, _vm._l((_vm.imageUrls), function(item) {
    return _c('img', {
      staticClass: "img",
      attrs: {
        "src": item
      }
    })
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c1d79c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userM/reportManage.vue
// module id = 1038
// module chunks = 0